exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* ---------- COLORS ----------*/\n.sickessAbsRow .subtitle {\n  font-weight: 500;\n  margin: 0;\n}\n.sickessAbsRow div {\n  margin: 7px 0;\n}\n.sickessAbsRow div:first-child {\n  margin: 0px;\n}\n.sickessAbsRow b {\n  font-weight: 500;\n}\n.sickessAbsRow span.title {\n  font-weight: 400;\n  font-size: 13px;\n  color: #78849e;\n}\n", ""]);

// exports
